/** DOM event when the tenant plan snapshot changes (socket push). */
export const TENANT_PLAN_UPDATED_EVENT = 'catalogofworks:tenant-plan-updated';

export function dispatchTenantPlanUpdated(): void {
  window.dispatchEvent(new CustomEvent(TENANT_PLAN_UPDATED_EVENT));
}
